import axios from 'axios';
import { getApiClientFront, getApiClientBack } from "../api/api";

  // const apiUrlMap = {
  //   // "pruebabopiweb.oepm.es": "http://pruebaconsultas5.oepm.es:5000",
  //   "pruebabopiweb.oepm.es": "https://pruebabopiweb.oepm.es/apibopiweb",
  //   "prebopiweb.oepm.es": "https://prebopiweb.oepm.es/apibopiweb",
  //   "bopiweb.oepm.es": "https://bopiweb.oepm.es/apibopiweb",
  
  //   "defaultApiUrl": "Error",
  //   "localhost": "http://localhost:5000",    
  // };
  
  // const api = axios.create({
  //   // baseURL: "http://localhost:8080/BopiWeb/"    
  //   baseURL: apiUrlMap[window.location.hostname] || apiUrlMap["defaultApiUrl"],
  // })

  export const busquedaTomos = async () => {
    const api = await getApiClientBack();
    const response = await api.get("/busquedaTomos");
    return response.data;
  };

  export const buscarNiza = async () => {
    const api = await getApiClientBack();
    const response = await api.get("/buscarNiza");
    return response.data;
  }

  export const buscarViena = async () => {
    const api = await getApiClientBack();
    const response = await api.get("/buscarViena");
    return response.data;
  }

  export const getBuscarAnotaciones = async (searchData, inicio, fin, columna, orden) => {
    const api = await getApiClientBack();
    const response = await api.post('/buscarAnotaciones', {
        body: JSON.stringify(searchData),
        tomo: searchData.tomo,
        textoBusqueda: searchData.textoBusqueda,
        numeroSolicitud: searchData.numeroSolicitud,
        fechaPublicacionDesde: searchData.fechaPublicacionDesde,
        fechaPublicacionHasta: searchData.fechaPublicacionHasta,
        solicitanteTitular: searchData.solicitanteTitular,
        agenteRepresentante: searchData.agenteRepresentante,
        codigoAgente: searchData.codigoAgente,
        recurrente: searchData.recurrente,
        denominacion: searchData.denominacion,
        denominacionTexto: searchData.denominacionTexto,
        numeroPrioridad: searchData.numeroPrioridad,
        productosServicios: searchData.productosServicios,
        clasificacionNiza: searchData.clasificacionNiza,
        elementoFigurativo: searchData.elementoFigurativo,
        clasificacionViena: searchData.selectedVienaClasses,
        selectedModalidadId: searchData.selectedModalidadId,
        selectedCapituloId: searchData.capitulo,
        selectedsubCapituloId: searchData.subcapitulo,
        selectedApartadoId: searchData.apartado,
        selectedSubapartadoId: searchData.subapartado,
        selectedLeyId: searchData.ley,
        numeroPublicacion: searchData.numeroPublicacion,
        inventor: searchData.inventor,
        fechaPrioridad: searchData.fechaPrioridad,
        clasificacionCIP: searchData.clasificacionCIP,
        disenador: searchData.disenador,
        clasificacionLocarno: searchData.clasificacionLocarno,
      }, {
        params: {
            inicio: inicio,
            fin: fin,
            columna: columna, 
            orden: orden
        }
    });
    return response.data;
  };

     export const getBuscarAnotacionesTotales = async (searchData, inicio, fin) => {
    const api = await getApiClientBack();
    const response = await api.post('/buscarAnotacionesTotales', {
        body: JSON.stringify(searchData),
        tomo: searchData.tomo,
        textoBusqueda: searchData.textoBusqueda,
        numeroSolicitud: searchData.numeroSolicitud,
        fechaPublicacionDesde: searchData.fechaPublicacionDesde,
        fechaPublicacionHasta: searchData.fechaPublicacionHasta,
        solicitanteTitular: searchData.solicitanteTitular,
        agenteRepresentante: searchData.agenteRepresentante,
        codigoAgente: searchData.codigoAgente,
        recurrente: searchData.recurrente,
        denominacion: searchData.denominacion,
        denominacionTexto: searchData.denominacionTexto,
        numeroPrioridad: searchData.numeroPrioridad,
        productosServicios: searchData.productosServicios,
        clasificacionNiza: searchData.clasificacionNiza,
        elementoFigurativo: searchData.elementoFigurativo,
        clasificacionViena: searchData.selectedVienaClasses,
        selectedModalidadId: searchData.selectedModalidadId,
        selectedCapituloId: searchData.capitulo,
        selectedsubCapituloId: searchData.subcapitulo,
        selectedApartadoId: searchData.apartado,
        selectedSubapartadoId: searchData.subapartado,
        selectedLeyId: searchData.ley,
        numeroPublicacion: searchData.numeroPublicacion,
        inventor: searchData.inventor,
        fechaPrioridad: searchData.fechaPrioridad,
        clasificacionCIP: searchData.clasificacionCIP,
        disenador: searchData.disenador,
        clasificacionLocarno: searchData.clasificacionLocarno,
      }, {
        params: {
            inicio: inicio,
            fin: fin
        }
    });
     
    return response.data;
  };